<template>
  <div
    v-if="$mq === 'sm'"
    :class="{ 'isToggled': toggle }"
    class="buheader-mob__nav position-relative"
  >
    <ul class="d-flex flex-column position-fixed">
      <button
        class="mobile-menu__close"
        @click="$emit('toggle')"
      >
        <i class="el-icon-close"></i>
      </button>
      <li class="nav-item px-4 py-3">
        <router-link class="nav-link" :to="`/bedrijvengids/${$route.params.slug}`" exact>
          Home
        </router-link>
      </li>
      <li
        v-for="(item, index) in menu"
        :key="index"
        class="nav-item px-4 py-3"
      >
        <a
          v-if="item.type === 'enjoj\\feed\\UrlItem'"
          class="nav-link"
          :href="item.itemable.url"
          target="_blank"
          v-html="item.text"
        />
        <router-link
          v-else class="nav-link"
          :to="getRoute(item)"
          v-html="item.text"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'ec-business-mobile-menu',
  props: {
    menu: {
      type: Array,
      default () {
        return []
      }
    },
    toggle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick (item) {
      this.$emit('route', item)
      this.$emit('toggle')
    },
    getRoute (item) {
      const route = `/bedrijvengids/${this.$route.params.slug}/${_.kebabCase(item.text)}`
      return route
    }
  }
}
</script>
